<template>
  <form method="post" @submit.prevent="onSend" novalidate>
    <div class="modal-card" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle }}
        </p>
      </header>

      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <b-field
            horizontal
            name="employee_code"
            attribute="attributes.meeting_sales"
            :label="$t('attributes.meeting_sales')"
          >
            <form-group
              name="employee_code"
              attribute="attributes.meeting_sales"
            >
              <b-input v-model="form.sales" name="sales" disabled></b-input>
            </form-group>
            <form-group
              name="meeting_quantity"
              attribute="attributes.meeting_quantity"
              :label="$t('attributes.meeting_quantity')"
              label-position="on-border"
              :custom-class="isOver ? 'has-text-danger' : ''"
            >
              <b-input
                v-model="applyCount"
                expanded
                disabled
                :custom-class="isOver ? 'has-text-danger' : ''"
              ></b-input>
            </form-group>
            <form-group
              name="meeting_remainder"
              attribute="attributes.meeting_remainder"
              :label="$t('attributes.meeting_remainder')"
              label-position="on-border"
              :custom-class="remainder === 0 ? 'has-text-danger' : ''"
            >
              <b-input
                :value="remainder > 0 ? remainder : 0"
                expanded
                disabled
                :custom-class="remainder === 0 ? 'has-text-danger' : ''"
              ></b-input>
              <p class="control">
                <b-button type="is-danger" @click.prevent.stop="onAddApplies">
                  <span class="icon">
                    <i class="mdi mdi-plus" />
                  </span>
                </b-button>
              </p>
            </form-group>
          </b-field>
          <form-group
            horizontal
            v-for="(apply, index) in applies"
            :key="index"
            :label="index === 0 ? $t('attributes.meeting_applicants') : ''"
          >
            <div class="columns is-variable is-1">
              <div class="column is-narrow is-flex is-align-items-center">
                <b-tag
                  :type="
                    apply.index > meeting.capacity ? 'is-warning' : 'is-primary'
                  "
                  size="is-medium"
                >
                  {{ apply.index.toString().padStart(3, '0') }}
                </b-tag>
              </div>
              <b-input
                :ref="`name-input-${index}`"
                v-model="apply.name"
                name="name"
                maxlength="20"
                :has-counter="false"
                :placeholder="
                  $t('message.please_input_', [$t('attributes.fullname')]) +
                    $t('message.word_limit', [20])
                "
                class="column"
              ></b-input>
              <b-input
                :ref="`tel-input-${index}`"
                v-model="apply.tel"
                name="tel"
                maxlength="20"
                :has-counter="false"
                :placeholder="
                  $t('message.please_input_', [$t('attributes.meeting_tel')]) +
                    $t('message.word_limit', [20])
                "
                class="column"
              ></b-input>
              <b-input
                :ref="`remark-input-${index}`"
                v-model="apply.remark"
                name="remark"
                maxlength="500"
                :has-counter="false"
                :placeholder="
                  $t('message.please_input_', [$t('attributes.remark')])
                "
                class="column is-4"
              ></b-input>
              <b-input
                :value="formatDateTime(apply.created_at)"
                class="column is-narrow"
                disabled
              ></b-input>
              <div class="column is-narrow">
                <b-button
                  type="is-danger"
                  class="is-fullwidth"
                  @click.prevent.stop="onDeleteApply(apply)"
                >
                  <span class="icon">
                    <i class="mdi mdi-delete" />
                  </span>
                </b-button>
              </div>
            </div>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-fullwidth" @click="$parent.close()">
          {{ $t('attributes.close') }}
        </b-button>
        <b-button
          :loading="sending"
          type="is-primary"
          class="is-fullwidth"
          native-type="submit"
        >
          {{ $t('attributes.meeting_apply_send') }}
        </b-button>
      </footer>
    </div>

    <b-loading
      :active.sync="sending"
      :is-full-page="false"
      :can-cancel="false"
    ></b-loading>
  </form>
</template>

<script>
import {
  maxLength,
  minLength,
  required,
  requiredIf
} from 'vuelidate/lib/validators'
import notifyService from '@/services/notifyService'
import Vue from 'vue'

export default {
  name: 'MeetingBriefingApplyForm',
  props: {
    meeting: {
      type: Object,
      required: true
    },
    meetingApplies: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean
    }
  },
  data() {
    let formTitle = this.$t('attributes.meeting_apply')
    formTitle += ` [${this.meeting.title}] ` + this.$t('attributes.briefing')

    const applies = this.meetingApplies.applies.map(apply => ({
      id: apply.id,
      index: apply.index,
      status: 'update',
      employee_code: apply.employee_code,
      employee_name: apply.employee_name,
      name: apply.name,
      tel: apply.tel,
      remark: apply.remark,
      created_at: apply.created_at
    }))
    if (applies.length === 0) {
      this.addNewApply(applies)
    }

    return {
      formTitle: formTitle,

      count: this.meetingApplies.applies.length,
      remainder: this.meeting.remainder,
      limit: this.meetingApplies.applies.length + this.meeting.remainder,

      applicants: applies,

      form: {
        sales: `[${this.meetingApplies.employee_code}] ${this.meetingApplies.employee_name}`,
        applicants: []
      }
    }
  },
  computed: {
    applies() {
      return this.applicants.filter(a => a.status !== 'delete')
    },
    applyCount() {
      if (this.count === this.applies.length) {
        return this.count
      } else {
        return `${this.count} -> ${this.applies.length}`
      }
    },
    isOver() {
      return this.applicants.length - this.count > this.remainder
    }
  },
  validations() {
    return {
      form: {
        applicants: {
          required,
          minLength: minLength(1),
          $each: {
            name: {
              requiredIf: requiredIf(function(model) {
                return model.status !== 'delete'
              }),
              maxLength: maxLength(20)
            },
            tel: { maxLength: maxLength(20) },
            remark: { maxLength: maxLength(200) }
          }
        }
      }
    }
  },
  methods: {
    onAddApplies() {
      this.$buefy.dialog.prompt({
        message: `增加申請人數？`,
        inputAttrs: {
          type: 'number',
          placeholder: '輸入人數',
          value: 1,
          min: 1,
          max: 100
        },
        trapFocus: true,
        onConfirm: value => {
          for (let i = 0; i < value; i++) {
            this.addNewApply(this.applicants)
          }
        }
      })
    },
    addNewApply(applicants) {
      const user = Vue.$auth.user()

      const last =
        applicants.length > 0 ? applicants[applicants.length - 1].index + 1 : 1

      applicants.push({
        id: null,
        index: last,
        status: 'create',
        employee_code: user.emp_code,
        employee_name: user.name,
        name: null,
        tel: null,
        remark: null,
        created_at: null
      })
    },
    onDeleteApply(apply) {
      if (this.applicants.length === 1) {
        notifyService.error('至少填寫一位旅客')
        return
      }

      if (apply.status === 'create' && !apply.name) {
        this.applicants = this.applicants
          .filter(a => a.index !== apply.index)
          .map(a => ({
            ...a,
            index: a.index > apply.index ? a.index - 1 : a.index
          }))
      } else {
        this.$buefy.dialog.confirm({
          message: this.$t('attributes.confirm_delete'),
          onConfirm: () => {
            this.deleteApply(apply)
          }
        })
      }
    },
    deleteApply(apply) {
      if (apply.status === 'create') {
        this.applicants = this.applicants
          .filter(a => a.index !== apply.index)
          .map(a => ({
            ...a,
            index: a.index > apply.index ? a.index - 1 : a.index
          }))
      } else {
        apply.status = 'delete'
      }
    },
    async onSend() {
      this.form.applicants = [...this.applicants]

      this.$v.$touch()
      if (this.$v.$invalid) {
        notifyService.error('請確實填寫每位旅客姓名')
        return
      }

      this.$emit('onSend', this.form.applicants)
    }
  }
}
</script>
